import { useFeatureFlag } from './use-feature-flag';
import { RateViewerView } from '../../components/rate-viewer/views/rate-viewer-view';
import { FeatureFlagDeclarations } from '../feature-flag-declarations';

export const useRateBrowserDefaultView = () => {
  const defaultView = useFeatureFlag(FeatureFlagDeclarations.rateBrowserDefaultView);

  return RateViewerView[defaultView];
};
